export default __webpack_public_path__ + "static/media/line.a68d1c0b.svg";